export function get(fetch, modelo, dados) {
  return fetch().post(modelo, dados);
}

export function getById(fetch, id, isLocal) {
  return fetch().post("/venda/consulta-det", { id, isLocal });
}
export function save(fetch, modelo, dados) {
  return fetch().post(modelo, dados);
}

export function deletar(fetch, dados) {
  return fetch().post("/venda/cancelar", dados);
}

export function getReceitas(fetch) {
  return fetch().post("", { rota: "/ven/get", modelo: "receitas" });
}